<template>
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <nav aria-label="Navigation" class="mb-4 sm:mb-0 sm:order-1" role="navigation">
            <ul class="flex justify-center">
                <li class="ml-3 first:ml-0">
                    <a :class="
            resource.links.prev
              ? prevNextClasses.active
              : prevNextClasses.disabled
          " :disabled="!resource.links.prev" :href="resource.links.prev"
                       class="btn bg-white border-slate-200 rounded-mg sm:rounded-lg">&lt;- Previous</a>
                </li>
                <li class="ml-3 first:ml-0">
                    <a :class="
            resource.links.next
              ? prevNextClasses.active
              : prevNextClasses.disabled
          " :disabled="!resource.links.next" :href="resource.links.next"
                       class="btn bg-white border-slate-200 rounded-mg sm:rounded-lg">Next -&gt;</a>
                </li>
            </ul>
        </nav>
        <div class="text-sm text-slate-500 text-center sm:text-left">
            Showing
            <span class="font-medium text-slate-600">{{ resource.meta.from ?? 0 }}</span>
            <span v-if="resource.meta.total"> to
            <span class="font-medium text-slate-600">{{ resource.meta.to ?? 0 }}</span></span>
            of
            <span class="font-medium text-slate-600">{{ resource.meta.total }}</span>
            results
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            prevNextClasses: {
                active: ["hover:border-slate-300", "text-blue-500"],
                disabled: ["text-slate-300", "cursor-not-allowed"],
            },
        };
    },
    props: ["resource"],
};
</script>
